import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { AuthUserController } from 'infraestructure/controllers/authUserController'
import { Status } from 'domain/models/apiResponse'
import { urlRoutes } from 'presentation/routes/config/urlRoutes/urlRoutes'
import {
  authUser,
  logoutError,
  logoutStart,
  logoutSuccess,
} from 'presentation/redux/slices/authUserSlice'
import { useError } from 'presentation/hooks'

export const useLogout = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(authUser)
  const { getErrorMessage } = useError()
  const logout = async (token: string) => {
    dispatch(logoutStart())
    try {
      const response = await AuthUserController.logout(token)
      if (response?.status === Status.success) {
        sessionStorage.clear()
        dispatch(logoutSuccess())
        navigate(urlRoutes.public.home.url)
      }
    } catch (err) {
      dispatch(logoutError(getErrorMessage({ error: err })))
    }
  }

  return { logout, isLoading, error }
}
